/* Stone Grindz theme · sg-card.js (deferred; load where a swipe row of product cards appears).
   Swipe rows on phones: the next card peeks in and a progress track follows the scroll (port of
   build/pages/shop/common.js SG.rows). Add to bag lives in sg-cart.js; live counts in sg-stock.js. */
(function () {
  'use strict';
  var SG = window.SG = window.SG || {};
  /* ---------- swipe rows: progress track ---------- */
  SG.rows = function(root){
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-row]'), function(row){
      if (row.__sgRow) return; row.__sgRow = true;
      var track = row.parentNode.querySelector('[data-track]');
      if (!track) return;
      var upd = function(){
        var w = Math.min(1, row.clientWidth / Math.max(1, row.scrollWidth));
        track.style.width = (w * 100) + '%';
        /* the row snaps each card to its start, so the last card can stop short of scrollWidth: count "the end" as
           the last card's snap point, so the track is full on the last card (Oct 11) */
        var max = row.scrollWidth - row.clientWidth, kids = row.children, last = kids[kids.length - 1], first = kids[0];
        if (last && first) max = Math.min(max, Math.max(1, last.offsetLeft - first.offsetLeft));
        var r = max > 0 ? Math.min(1, row.scrollLeft / max) : 0;
        if (row.scrollWidth - row.clientWidth - row.scrollLeft < 4) r = 1;
        track.style.transform = 'translateX(' + (r * (1 / w - 1) * 100) + '%)';
      };
      row.addEventListener('scroll', function(){ requestAnimationFrame(upd); }, {passive: true});
      window.addEventListener('resize', upd);
      upd();
    });
  };
  if (SG.ready) SG.ready(SG.rows); else document.addEventListener('DOMContentLoaded', function () { SG.rows(document); });
})();
